import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Quilleditor } from "../../Quilleditor/Quilleditor";
import RangeSilder from "../../RangeSilder/RangeSilder";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";

function InterestItem(props) {
  const [t, i18n] = useTranslation("common");

  return (
    <>
      <div className="row px-3">
        <div className="col-md-12 mb-3 mr-2">
          {!props.showPopup && (
            <img
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
              alt="trash"
              className="ml-1 delete_icon float-right"
              onClick={props.handleItemDelete}
            />
          )}
        </div>
        <div className="col-md-6">
          <EditorInput
            label={t(`interests.name`)}
            value={props.res.name}
            name="name"
            autoComplete="off"
            className={`form-control  ${props.sectionId}focus${props.index}`}
            onChange={props.resumeHandler}
            onBlur={props.resumeUpdate}
          />
          {/* <label>{t(`interests.name`)}</label>
                      <img src="/images/trash.svg" alt="trash" className="ml-1" onClick={props.handleDelete}/>
                      <input
                        type="text"
                        className={`form-control customform ${props.sectionId}focus${props.index}`}
                        name="name"
                        value={props.res.name}
                        onChange={props.resumeHandler}
                      /> */}
        </div>
        {/* <div className="col-md-6">
          <label>{t(`interests.level`)}</label>
          <RangeSilder
            value={props.res.level}
            resumeHandler={props.resumeHandler}
            onBlur={props.resumeUpdate}
          />
        </div> */}
        {/* <div className={props.showPopup ? " col-md-12 mb-1 mt-3 d-flex" : " col-md-12  mt-3 d-flex"}>
					{(props.saveIndex == props.index) ? (
						<ResumeButton
							success
							alt="plus"
							title="Save"
						/>
						// <button
						// 	type="button"
						// 	className="btn submitbtn disable_btn"
						// >
						// 	<i
						// 		className="fa fa-circle-o-notch fa-spin"
						// 		style={{ marginRight: "5px" }}
						// 	/>

						// 	Save
						// </button>
					) : (
						<ResumeButton
							success
							alt="plus"
							title="Save"
							className="mr-2"
							onClick={() => {
								props.resumeUpdate()
								props.setSaveIndex()
							}}
						/>
						// <button
						// 	type="button"
						// 	className="btn submitbtn"
						// 	onClick={() => {
						// 		props.resumeUpdate()
						// 		props.setSaveIndex()
						// 	}}
						// >Save</button>
					)}
					<ResumeButton
						white
						alt="plus"
						title="Cancel"
						onClick={props.resumeUpdateCancel}
					/>
				</div> */}
      </div>
    </>
  );
}

export default InterestItem;
